:host {
  display: flex;
  aspect-ratio: 1/1;
  height: var(--size-8);
  align-items: center;
  justify-content: center;
}

sl-dropdown {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  &::part(trigger) {
    height: 100%;
    width: 100%;
  }
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    cursor: pointer;
    padding: 0;
    margin: 0;
  }
}

sl-menu-item[disabled] {
  &::part(base) {
    cursor: default;
    opacity: 1;
  }
}
